/*
 * @Author: your name
 * @Date: 2022-01-12 10:33:42
 * @LastEditTime: 2022-01-12 10:37:42
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wp-empowerment-tools-web\src\services\material.ts
 */

import { MATERIAL } from "../const"
import request from "../utils/request"
import API from "../utils/typings"
/**
 * @author hz21087108
 * @Date 2021/8/6
 * @description 查询营销素材内容
 * @param {Object} params 查询参数
 * @param {Number} params.state 状态
 * @param {String} params.queryText 模糊查询字符串
 * @param {Object} params.page 分页参数
 * @param {Number} params.page.size 单页长度
 * @param {Number} params.page.current 当前页
 * @returns <Promise<any>>
 */
const getMarerialContent = (params: API.MaterialQueryParams) => {
  return request.post(MATERIAL.getMaterialContent, {
    data: params,
  })
}

/**
 * @author hz21087108
 * @Date 2021/8/9
 * @description 查询营销素材内容
 * @returns <Promise<any>>
 */
const getChatContents = () => {
  return request.get(MATERIAL.getChatContents)
}

const getCustomerChat = (params: any) => {
  return request.get(MATERIAL.getSelectAllBusinessChat, { params })
}

/**
 * @Description 根据code请求微信用户的openid
 * @author hz21087108
 * @date 2021-08-17
 * @param {string} code:string
 * @returns {Promise<any}
 */
const getUsrUnionId = (code: string) => {
  return request.get(MATERIAL.getUserUnionId, {
    params: {
      code,
    },
  })
}

/**
 * @Description 根据code请求微信用户的openid
 * @author hz21087108
 * @date 2021-08-17
 * @param {string} code:string
 * @returns {Promise<any}
 */
const getUserInfoByCode = (code: string) => {
  return request.get(MATERIAL.getUserInfoByCode, {
    params: {
      code,
    },
  })
}
/**
 * @Description 获取微信公众号appId
 * @author hz21087108
 * @date 2021-08-18
 * @returns {<Promise<any>>}
 */
const getWeixinAppId = () => {
  return request.get(MATERIAL.getWxAppId)
}
const selectShareUrl = (data: any) => {
  return request.get(`${MATERIAL.selectShareUrl}`, { params: data })
}

///v1/material/content/uploadByFile
const uploadByFile = (params: any) => {
  return request.post(`${MATERIAL.uploadByFile}`, {
    requestType: "form",
    data: params,
    timeout: 30000,
  })
}

//
const sendLookRemind = (params: any) => {
  return request.get(`${MATERIAL.sendLookRemind}`, { params })
}

const sendLookRemindV2 = (params: any) => {
  const isIos = /ipad|iPhone|Mac/i.test(window.navigator.userAgent)
  if (isIos) {
    let headers = {
      type: "application/json",
    }
    let blob = new Blob([JSON.stringify(params)], headers)
    window.navigator.sendBeacon(
      `/api${MATERIAL.sendLookRemind2}?tenantCode=${params.tenantCode}`,
      blob,
    )
  } else {
    return request.post(
      `${MATERIAL.sendLookRemind2}?tenantCode=${params.tenantCode}`,
      {
        data: params,
        timeout: 30000,
      },
    )
  }
}

export {
  getCustomerChat,
  // 查询营销素材内容
  getMarerialContent,
  // 查询营销素材标签
  getChatContents,
  getUsrUnionId, // 根据code换取openid（个人微信）
  getWeixinAppId, // 获取微信appId
  getUserInfoByCode, //根据code换取用户信息（个人微信）
  selectShareUrl,
  uploadByFile,
  sendLookRemind,
  sendLookRemindV2,
}
